import {useEffect,useSyncExternalStore} from 'react';
import type {User} from '@jungles/shared';
import {api,getSessionEpoch} from '../lib/api';
import {createNameAutosave} from '../lib/profile-name-autosave';
import {useSession} from '../app/session';
import {useToast} from '../app/toast';
import {ProfilePhotoEditor} from './ProfilePhotoEditor';
let retained:{key:string;queue:ReturnType<typeof createNameAutosave>}|undefined;
export function ProfileIdentity({user}:{user:User}) {
 const {updateIdentity}=useSession();const toast=useToast();
 const epoch=getSessionEpoch(),owner=user.id,key=epoch+':'+owner;
 if(retained?.key!==key)retained={key,queue:createNameAutosave(user.name,()=>getSessionEpoch()===epoch,async name=>{
   if(getSessionEpoch()!==epoch)return;
   const next=await api.patch<User>('/api/me',{name});
   if(getSessionEpoch()===epoch&&next.id===owner)updateIdentity(owner,{name:next.name});
 },message=>toast(message))};
 const queue=retained.queue;
 const state=useSyncExternalStore(queue.subscribe,queue.snapshot);
 useEffect(()=>{
   const leave=(e:BeforeUnloadEvent)=>{const s=queue.snapshot();if(s.busy||s.draft!==s.saved){e.preventDefault();e.returnValue=''}};
   window.addEventListener('beforeunload',leave);
   return()=>{window.removeEventListener('beforeunload',leave);if(!queue.snapshot().error)void queue.flush().catch(()=>{})};
 },[queue]);
 return <div className="profile-identity">
  <ProfilePhotoEditor key={key} user={user} name={state.draft}/>
  <label className="fl">Имя<input className="f" value={state.draft} onChange={e=>queue.edit(e.target.value)} onBlur={()=>{if(!queue.snapshot().error)void queue.flush().catch(()=>{})}} maxLength={64}/><span className="nt">Имя и фото сохраняются автоматически. Фото видно другим участникам.</span>
   {state.busy&&<span role="status">Сохраняем имя…</span>}
   {state.error&&<span role="alert">{state.error}</span>}
   {state.error&&<span><button type="button" className="b" onClick={()=>void queue.flush().catch(()=>{})}>Повторить сохранение имени</button><button type="button" className="b" onClick={queue.discard}>Отменить изменение имени</button></span>}
  </label>
 </div>;
}
